import { QueryString } from "@/app/shared/filter";

export class CheckinStatusQueryString extends QueryString {
    public override get isNoValue(): boolean {
        return this._value === '';
    }
    override _fieldModelName: string = "checkinStatus";
    override _fieldName: string = "checkinStatus";
    constructor(value: any = '', sort: number = 0) {
        super();
        this._value = value;
    }
}